// src/redux/slices/supervisors/supervisorsSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { fetchSupervisors, createSupervisor, assignDelegatesToSupervisor } from "./supervisorsThunk";

const initialState = {
  supervisorsList: {
    data: [],
    loading: false,
    error: null,
  },
  // On peut ajouter des états spécifiques pour la création ou la mise à jour si besoin
  // mais pour l'instant, on se concentre sur la liste principale.
};

const supervisorsSlice = createSlice({
  name: "supervisors",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Cas pour fetchSupervisors
      .addCase(fetchSupervisors.pending, (state) => {
        state.supervisorsList.loading = true;
        state.supervisorsList.error = null;
      })
      .addCase(fetchSupervisors.fulfilled, (state, action) => {
        state.supervisorsList.loading = false;
        state.supervisorsList.data = action.payload;
      })
      .addCase(fetchSupervisors.rejected, (state, action) => {
        state.supervisorsList.loading = false;
        state.supervisorsList.error = action.payload;
      })

      // Cas pour createSupervisor
      .addCase(createSupervisor.pending, (state) => {
        state.supervisorsList.loading = true; // On peut utiliser le même loading
      })
      .addCase(createSupervisor.fulfilled, (state, action) => {
        state.supervisorsList.loading = false;
        // Ajoute le nouveau superviseur à la liste existante
        state.supervisorsList.data.push(action.payload);
      })
      .addCase(createSupervisor.rejected, (state, action) => {
        state.supervisorsList.loading = false;
        state.supervisorsList.error = action.payload;
      })
      
      // Cas pour assignDelegatesToSupervisor
      .addCase(assignDelegatesToSupervisor.pending, (state) => {
        state.supervisorsList.loading = true;
      })
      .addCase(assignDelegatesToSupervisor.fulfilled, (state, action) => {
        state.supervisorsList.loading = false;
        // Met à jour le superviseur modifié dans la liste
        const index = state.supervisorsList.data.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.supervisorsList.data[index] = action.payload;
        }
      })
      .addCase(assignDelegatesToSupervisor.rejected, (state, action) => {
        state.supervisorsList.loading = false;
        state.supervisorsList.error = action.payload;
      });
  },
});

export default supervisorsSlice.reducer;